(function() {
    'use strict';
    /**
     * @memberof wbDashboard
     * @ngdoc Services
     * @name Notification
     * @description Notification service to handle notification data
     */
    angular.module('wbDashboard').factory('Guidance', ['NotificationBase', function (NotificationBase) {
        var guidance = NotificationBase({data: {
            type: "guidance",
            all: true
        }});

        guidance.complete = function() {
            var variations;

            var date = new Date();

            if (date.getMonth()===0 && date.getDate() <= 6) {
                variations = [
                    {
                        title: "Happy " + date.getFullYear(),
                        message: "You're off to a great start. Keep it up!",
                        imageToken: "confetti"
                    },
                    {
                        title: "Cheers",
                        message: "Celebrate everything you achieved last year!",
                        imageToken: "beer"
                    },
                ];
            } else {
                variations = [
                    {
                        title: "All Set",
                        message: "We'll keep monitoring your account for more guidance.",
                        imageToken: "confetti"
                    },
                    {
                        title: "Squared Away",
                        message: "That's all for now. Check back soon.",
                        imageToken: "hands"
                    },
                    {
                        title: "Rest Easy",
                        message: "Great job catching up on your financial progress!",
                        imageToken: "beach"
                    },
                    {
                        title: "Gold Star",
                        message: "Keep it up! Your future's looking brighter and brighter.",
                        imageToken: "star"
                    },
                    {
                        title: "Easy As Pie",
                        message: "Check back next week for another slice of progress.",
                        imageToken: "pie"
                    },
                    {
                        title: "Cheers",
                        message: "Take a moment to celebrate your financial focus!",
                        imageToken: "beer"
                    },
                    {
                        title: "Chow For Now",
                        message: "We'll provide another serving of guidance soon.",
                        imageToken: "soup"
                    },
                    {
                        title: "Until Next Time",
                        message: "You're all caught up! See you soon.",
                        imageToken: "clap"
                    },
                    {
                        title: "On Point",
                        message: "Nice work reviewing your weekly progress!",
                        imageToken: "dart"
                    },
                    {
                        title: "Wise Move",
                        message: "Check back next week to to stay on top of your progress!",
                        imageToken: "joystick"
                    }
                ];
            }

            var index = Math.floor(Math.random() * variations.length);

            return variations[index];

        };

        return guidance;
    }]);
})();
